import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, message, Space, Tooltip, Modal} from 'antd';
import _ from 'lodash';

import {CheckOutlined, TeamOutlined, UserOutlined, AuditOutlined} from '@/icons';
import {PageGrid} from '@/component';
import {getColumns} from './userListColumns';

import styles from '../MainPanel.module.less';
import UserViewModal from '@/page/admin/DepartsPage/UserViewModal';

export default function UserTabPane({departIds, searchValue, onAddSelected, parentUserId}) {
    const tableRef = useRef();
    const viewRef = useRef();

    const [url, setUrl] = useState(null);
    const [groupUrl, setGroupUrl] = useState(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!_.isEmpty(departIds)) {
            const depId = departIds[0];
            if (searchValue) {
                setUrl(`/departs/${depId}/users?s=${encodeURIComponent(searchValue)}`);
            } else {
                setUrl(`/departs/${depId}/users`);
            }
        }
    }, [departIds, searchValue]);

    function onUserSelect(record) {
        if (record.id == parentUserId) {
            message.warning('不能添加用户自己').then(r => {
                return false;
            });
        } else {
            onAddSelected('users', {id: record.id, name: record.name, extId: record.extId});
        }
    }

    function onShowGroupMember(record) {
        console.log('record', record);
        setGroupUrl(`/reportLine/list/${record.extId}`);
        setVisible(true);
    }

    function onUserGroupSelect(record) {
        onAddSelected('groups', {id: record.id, name: record.name, extId: record.extId});
    }

    function onNameClick(record) {
        return () => {
            viewRef.current.showModal(record);
        };
    }

    const columns = getColumns(['avatar', 'cwid', 'cName', 'eName', 'extId'], {onNameClick});
    const groupColumns = getColumns(['avatar', 'cwid', 'cName', 'eName', 'extId'], {onNameClick});

    const actions = [
        {
            key: 'selectUser',
            title: '选择成员',
            hide: false,
            icon: <CheckOutlined style={{marginRight: 10}} />,
            onClick: onUserSelect,
        },
        {
            key: 'selectGroup',
            title: '选择部门',
            hide: false,
            icon: <CheckOutlined style={{marginRight: 10}} />,
            onClick: onUserGroupSelect,
        },
    ];
    const columnAction = {
        title: '操作',
        key: 'selAction',
        width: 220,
        // eslint-disable-next-line react/display-name
        // render: (text, record) => <RowAction actions={actions} record={record} />,
        render: (text, record) => {
            let isCheck = false;
            let title = '';
            if (parentUserId && parentUserId == record.id) {
                isCheck = true;
                title = '不能选择用户自己';
            }

            return (
                <Space>
                    <Tooltip title={title}>
                        <Button
                            disabled={isCheck}
                            icon={<UserOutlined />}
                            onClick={() => onUserSelect(record)}
                        >
                            选择成员
                        </Button>
                    </Tooltip>
                    {/*<Button icon={<TeamOutlined />} onClick={() => onUserGroupSelect(record)}>*/}
                    {/*    选择部门*/}
                    {/*</Button>*/}
                    {/*<Button*/}
                    {/*    type="link"*/}
                    {/*    icon={<AuditOutlined />}*/}
                    {/*    onClick={() => onShowGroupMember(record)}*/}
                    {/*>*/}
                    {/*    查看部门成员*/}
                    {/*</Button>*/}
                </Space>
            );
        },
    };
    columns.push(columnAction);

    return (
        <div className={styles.tabContent2}>
            <div className={styles.tabContentMain}>
                <div className={styles.tabContentInner}>
                    {url && (
                        <PageGrid
                            ref={tableRef}
                            url={url}
                            columns={columns}
                            rowKey="id"
                            paginationProps={{simple: true, showSizeChanger: false}}
                        />
                    )}
                    <Modal
                        title="团队成员"
                        visible={visible}
                        footer={null}
                        onCancel={() => {
                            setVisible(false), setGroupUrl(null);
                        }}
                    >
                        {groupUrl && (
                            <PageGrid
                                ref={tableRef}
                                url={groupUrl}
                                columns={groupColumns}
                                rowKey="id"
                                paginationProps={{simple: true, showSizeChanger: false}}
                            />
                        )}
                    </Modal>

                    <UserViewModal ref={viewRef} />
                </div>
            </div>
        </div>
    );
}

UserTabPane.propTypes = {
    /**
     * 可见的部门 id
     *
     * 如果为为 null 或 undefined, 表示所有部门可见
     *
     * 如果是 [] ，表示所有不可见
     * 如果有值，则对应部门和子部门可见
     */
    allowDepartIds: PropTypes.arrayOf(PropTypes.string),

    /**
     * 查询条件
     */
    searchValue: PropTypes.string,

    clearSearchValue: PropTypes.func,

    onAddSelected: PropTypes.func.isRequired,
};
